[
  null,
  {
    "id": 1,
    "description": "poštový peňažný poukaz",
    "textToTranslate": "payment-mode.postal-order"
  },
  {
    "id": 2,
    "description": "zrážka zo mzdy",
    "textToTranslate": "payment-mode.salary-deduction"
  },
  {
    "id": 3,
    "description": "bankový prevod",
    "textToTranslate": "payment-mode.bank-transfer"
  },
  {
    "id": 4,
    "description": "sporožíro",
    "textToTranslate": "payment-mode.budget-account"
  },
  {
    "id": 5,
    "description": "hotovosť",
    "textToTranslate": "payment-mode.cash"
  },
  {
    "id": 6,
    "description": "inkaso z účtu",
    "textToTranslate": "payment-mode.premium-collection"
  },
  {
    "id": 7,
    "description": "banková zloženka",
    "textToTranslate": "payment-mode.bank-cheque"
  },
  {
    "id": 8,
    "description": "hotovosť na inkasný blok",
    "textToTranslate": "payment-mode.cash-ib"
  },
  {
    "id": 9,
    "description": "platba na návrhopoistku",
    "textToTranslate": "payment-mode.payment-on-proposal"
  },
  {
    "id": 10,
    "description": "skupinová platba",
    "textToTranslate": "payment-mode.group-payment"
  },
  {
    "id": 11,
    "description": "hromadná",
    "textToTranslate": "payment-mode.collective-payment"
  },
  {
    "id": 12,
    "description": "individuálna",
    "textToTranslate": "payment-mode.individual"
  },
  null, null, null, null, null, null, null, null, null, null, null,
  {
    "id": 24,
    "description": "zrážka zo mzdy HIP",
    "textToTranslate": "payment-mode.salary-deduction-by-cumulative-payment"
  },
  {
    "id": 25,
    "description": "Tatrapay",
    "textToTranslate": "payment-mode.tatrapay"
  },
  {
    "id": 26,
    "description": "Cardpay",
    "textToTranslate": "payment-mode.cardpay"
  },
  {
    "id": 27,
    "description": "KOMBI platba 1. poistného",
    "textToTranslate": "payment-mode.combi-first-premium-payment"
  },
  {
    "id": 28,
    "description": "SporoPay",
    "textToTranslate": "payment-mode.sporopay"
  },
  null,
  {
    "id": 30,
    "description": "Volksbank",
    "textToTranslate": "payment-mode.volksbank"
  },
  {
    "id": 31,
    "description": "Unicredit",
    "textToTranslate": "payment-mode.unicredit"
  },
  {
    "id": 32,
    "description": "VUB banka",
    "textToTranslate": "payment-mode.vub"
  },
  {
    "id": 33,
    "description": "iná PZ",
    "textToTranslate": "payment-mode.other-policy"
  },
  {
    "id": 34,
    "description": "vkladové poistenie",
    "textToTranslate": "payment-mode.deposit-insurance"
  },
  {
    "id": 35,
    "description": "Odkup / pôžička",
    "textToTranslate": "payment-mode.surrender-loan"
  }
]
